<template>
  <v-container class="mt-6 grey lighten-4 rounded-lg" v-if="showBanner">
    <v-row class="align-center px-md-12">
      <v-col cols="12" md="8" class="pt-6 py-md-0">
        <div class="d-flex flex-column flex-md-row align-center">
          <img
            src="@/assets/icons/bookaweb-logo.svg"
            alt="Bookaweb logo"
            width="42"
            max-width="42"
            class="mr-3 flex-shrink-0"
            loading="lazy"
          >
          <span class="font-weight-bold text-h5 text-center text-md-left mt-4 mt-md-0">
            {{ $t('app-banner-title') }}
          </span>
        </div>
        <div class="d-flex justify-center justify-md-start align-center mt-6">
          <a :href="$store.state.appDownloadLinks.android" target="_blank" rel="noopener noreferrer" class="mr-6">
            <img src="@/assets/icons/app-google-play-store.svg" alt="Google Play logo" height="48" loading="lazy">
          </a>
          <a :href="$store.state.appDownloadLinks.ios" target="_blank" rel="noopener noreferrer">
            <img src="@/assets/icons/app-apple-store.svg" alt="App Store logo" height="48" loading="lazy">
          </a>
        </div>
      </v-col>
      <v-col cols="12" md="4" class="d-flex align-center justify-center py-0 px-0 pt-4 pt-md-6">
        <div class="app-screenshot-wrapper d-flex justify-center justify-md-end align-start">
          <img v-if="$i18n.locale === 'sr'" src="@/assets/ios-screenshot-sr.png" alt="Bookaweb app screenshot" loading="lazy">
          <img v-else src="@/assets/ios-screenshot-en.png" alt="Bookaweb app screenshot" loading="lazy">
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'AppPromotionBanner',
  computed: {
    showBanner() {
      return !['cordova-app', 'cordova-app-ios'].some((ua) => window.navigator.userAgent.includes(ua));
    },
  },
};
</script>

<style scoped>
.app-screenshot-wrapper {
  height: 250px;
  overflow: hidden;
}
.app-screenshot-wrapper img {
  object-fit: cover;
  width: 80%;
  max-width: 80%;
}
</style>
